const pearl = {
  pearl: 'Pearl',
  amountTips: 'Minimum pearls for sending: {{ num }}',
  selectUserTips: "Enter the recipient's account",
  inputAmountTips: 'Enter the amount to send',
};

export default {
  title: 'Send',
  success: 'Send successfully',
  transfer: 'Transfer',
  transfering: 'Transfering...',
  successTips: 'Please check the ID and amount you have sent',
  sellResultTitle: 'For coin',
  sellSuccessMain: 'Exchange Success',
  sellFailureDescription:
    'The current transaction is abnormal, please go to the transaction details to verify the result',
  pearl,
};
